import { func, elementType, node } from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StopPropagation(_ref) {
  let {
    as = 'div',
    onClick,
    onKeyDown,
    children,
    ...props
  } = _ref;
  const Component = as;
  return /*#__PURE__*/_jsx(Component, {
    onClick: event => {
      event.stopPropagation();
      if (onClick) onClick(event);
    },
    onKeyDown: event => {
      if (event.key === 'Enter') event.stopPropagation();
      if (onKeyDown) onKeyDown(event);
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    ,
    ...props,
    children: children
  });
}
StopPropagation.defaultProps = {
  as: 'div',
  onClick: undefined,
  onKeyDown: undefined,
  children: undefined
};
StopPropagation.propTypes = {
  onClick: func,
  onKeyDown: func,
  as: elementType,
  children: node
};
//# sourceMappingURL=StopPropagation.js.map